<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <a
    v-if="href"
    :class="b('', { view })"
    :href="displayedHref"
    :target="target || undefined"
    :download="download ? '' : undefined"
  >
    {{ $t(label) }}
  </a>

  <router-link v-else :class="b('', { view })" :to="to">
    {{ $t(label) }}
  </router-link>
</template>
